import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-process-list-interview-dialog',
  templateUrl: './user-process-list-interview-dialog.component.html',
  styleUrls: ['./user-process-list-interview-dialog.component.scss']
})
export class UserProcessListInterviewDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UserProcessListInterviewDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  responder(aceitou: boolean) {
    this.dialogRef.close(aceitou);
  }

  checkDateAndConfirm(event: MouseEvent, dateStart: string, timeStart: string): void {
    const currentDate = new Date(); // Data e hora atual
  
    // Quebra a string "2025-01-22" em ano, mês e dia
    const [year, month, day] = dateStart.split('-').map(Number);
  
    // Quebra a string "12:00" em hora e minuto
    const [hour, minute] = timeStart.split(':').map(Number);
  
    // Cria a data ajustada (mês é zero-indexado, hora e minuto são considerados)
    const startDate = new Date(year, month - 1, day, hour, minute);
    
    // console.log('currentDate', currentDate);
    // console.log('startDate', startDate);

    // Compara as datas e horas
    if (currentDate < startDate) {
      const proceed = confirm('A entrevista ainda não começou. Deseja continuar mesmo assim?');
      if (!proceed) {
        event.preventDefault(); // Impede o redirecionamento
      }
    }
  }
  
  formatTime(time: string): string {
    return time.substring(0, 5); // Retorna apenas os primeiros 5 caracteres (HH:mm)
  }

}
